import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { logger } from '../utils/logger.util';


/** Options pour ouvrir la visionneuse d'image globale (URL présignée, compatible mobile). */
export interface ImagePlayerOpenOptions {
  title: string;
  /** Clé S3/MinIO — une URL présignée sera récupérée. */
  s3Key?: string;
  /** URL déjà résolue — prioritaire sur s3Key. */
  imageUrl?: string;
  contentType?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ImagePlayerService {
  private readonly requestSubject = new BehaviorSubject<ImagePlayerOpenOptions | null>(null);

  readonly request$ = this.requestSubject.asObservable();

  open(options: ImagePlayerOpenOptions): void {
    if (!options.imageUrl && !options.s3Key) {
      logger.warn('[ImagePlayerService] open() requiert imageUrl ou s3Key');
      return;
    }
    this.requestSubject.next(options);
  }

  close(): void {
    this.requestSubject.next(null);
  }
}
